// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"4476f3cd7a3da02d","5763":"bc88b3be01516e7d","7222":"67ad211859d5b1ef","7937":"fdd1c4ecb64b2137"}[chunkId] + ".js";
};